import axios from 'axios'
import {DeleteProductSchemeModel, ProductSchemeModel} from '../Model'
import {ParamsModel} from 'src/app/modules/common/Model'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const ProductScheme = `${API_URL}/master-data`

export const service = {
  getProductScheme: (params: ParamsModel) => {
    return axios.get(`${ProductScheme}/table-data?table=md_scheme_types`, {params})
  },

  getProductSchemeDropdown: () => {
    return axios.get(`${ProductScheme}/list`)
  },

  postProductScheme: (body: ProductSchemeModel) => {
    return axios.post(ProductScheme, body)
  },

  updateProductScheme: (body: ProductSchemeModel, id: string) => {
    return axios.post(`${ProductScheme}/update`, {...body, id: id})
  },

  deleteProductScheme: (data: DeleteProductSchemeModel) => {
    return axios.delete(`${ProductScheme}/destroy`, {data})
  },

  singleActivatedProductScheme: (body: any) => {
    return axios.post(`${ProductScheme}/enable/data`, body)
  },

  singleDeactivatedProductScheme: (body: any) => {
    return axios.post(`${ProductScheme}/disable/data`, body)
  },
}
